import {AbstractControl, ValidationErrors} from '@angular/forms';
import {Utils} from '../utils.class';

/**
 * Part-time rate of a user during a period, dates as yyyy-MM-dd. A period without end_date is running.
 */
export class UserAssignment {
    id?: number;
    begin_date: string;
    end_date?: string | null;
    part_time_rate: number;

    static current(assignments: UserAssignment[] | undefined, date = new Date()): UserAssignment | undefined {
        const day = Utils.formatDate(date);
        return assignments?.find(assignment => assignment.begin_date <= day && (!assignment.end_date || assignment.end_date >= day));
    }

    /**
     * Validator for a FormArray of periods with Date values: each period ends on or after its begin
     * and periods don't overlap, like the API validates.
     */
    static validatePeriods(control: AbstractControl): ValidationErrors | null {
        const periods = (control.value as {begin_date: Date | null, end_date: Date | null}[])
            .filter(period => period.begin_date)
            .sort((a, b) => a.begin_date.getTime() - b.begin_date.getTime());

        if (periods.some(period => period.end_date && period.end_date < period.begin_date)) {
            return {endBeforeBegin: true};
        }
        if (periods.some((period, i) => i > 0 && (!periods[i - 1].end_date || periods[i - 1].end_date >= period.begin_date))) {
            return {overlap: true};
        }
        return null;
    }
}
